import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';

class FingerprintService {
    constructor() {
        this.coreData = {
            deviceId: '',
            data: { browserLanguage: '', platformText: '', timeStamp: '', timeZoneOffset: '', userAgent: '' },
            version: 1
        };
    }
    get() {
        // tslint:disable-next-line: variable-name
        return new Promise((resolve, _reject) => {
            Fingerprint2.get((components) => {
                // Device ID below is from IRS DeviceID code for TY2019.pdf
                // which lives in \\pssg.local\tax\1040\Federal\ELF\Specs\2019\MeFSchema
                const stringtohash = components.map((pair) => {
                    return pair.value;
                }).join('###');
                this.coreData.deviceId = CryptoJS.SHA1(stringtohash);
                this.coreData.data.browserLanguage = navigator.language;
                this.coreData.data.platformText = navigator.platform;
                this.coreData.data.userAgent = navigator.userAgent;
                const offsetTZNumber = new Date().getTimezoneOffset();
                let timeZoneOffsetText = offsetTZNumber.toString();
                if (offsetTZNumber > 0) {
                    timeZoneOffsetText = '+' + timeZoneOffsetText;
                }
                this.coreData.data.timeZoneOffset = timeZoneOffsetText;
                this.coreData.data.timeStamp = new Date().toISOString();
                resolve(JSON.stringify(this.coreData));
            });
        });
    }
}
FingerprintService.ɵfac = function FingerprintService_Factory(t) { return new (t || FingerprintService)(); };
FingerprintService.ɵprov = i0.ɵɵdefineInjectable({ token: FingerprintService, factory: FingerprintService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FingerprintService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class FingerprintComponent {
    constructor() { }
    ngOnInit() {
    }
}
FingerprintComponent.ɵfac = function FingerprintComponent_Factory(t) { return new (t || FingerprintComponent)(); };
FingerprintComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FingerprintComponent, selectors: [["bm-tax-fingerprint"]], decls: 2, vars: 0, template: function FingerprintComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, " bm-tax-fingerprint works! ");
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FingerprintComponent, [{
        type: Component,
        args: [{
                selector: 'bm-tax-fingerprint',
                template: `
    <p>
    bm-tax-fingerprint works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class FingerprintModule {
}
FingerprintModule.ɵfac = function FingerprintModule_Factory(t) { return new (t || FingerprintModule)(); };
FingerprintModule.ɵmod = i0.ɵɵdefineNgModule({ type: FingerprintModule });
FingerprintModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FingerprintModule, { declarations: [FingerprintComponent], exports: [FingerprintComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FingerprintModule, [{
        type: NgModule,
        args: [{
                declarations: [FingerprintComponent],
                imports: [],
                exports: [FingerprintComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fingerprint
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FingerprintComponent, FingerprintModule, FingerprintService };
